import React from "react"
import Layout from "../Layout";
import {BigCenter} from "../shared/mix";
import styled, {keyframes} from "styled-components";
import WelcomeBanner from "./WelcomeBanner";
import Logos from "./Logos";
import projects from "../../consts/projects";
import Reference from "./Reference";
import CTA from "../CTA";
import {Link} from "react-router-dom";
import {SecondaryBtn} from "./WelcomeBanner";
import SEO from "../SEO";

function randomInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const Welcome = () => {
    return (
        <Layout>
            <SEO
                title="Tvorba webů, aplikací a systémů na míru"
                description="Matěj Půhoný — web developer z Pardubic. Navrhuji a vyvíjím moderní webové stránky, aplikace a systémy na míru. React, Next.js, Node.js, Laravel. Od nápadu po funkční produkt."
                breadcrumb={false}
                jsonLd={{
                    "@type": "ItemList",
                    "@id": "https://puhony.eu/#featured-projects",
                    "name": "Vybrané projekty",
                    "itemListElement": [projects[0], projects[1], projects[4]].map((p, i) => ({
                        "@type": "ListItem",
                        "position": i + 1,
                        "name": p.name,
                        "description": p.sub,
                        "url": p.urls.web ?? "https://puhony.eu/reference/"
                    }))
                }}
            />
            <BigCenter>
                <WelcomeBanner project={projects[randomInt(0, projects.length - 1)]}/>
            </BigCenter>
            <BigCenter>
                <Logos/>

                <SectionHeader>
                    <SectionLabel>Vybrané projekty</SectionLabel>
                    <SectionTitle>Na čem jsem pracoval</SectionTitle>
                </SectionHeader>

                <Reference project={projects[0]} index={0}/>
                <Reference project={projects[1]} index={1}/>
                <Reference project={projects[4]} index={2}/>

                <MoreLink>
                    <Link to="/reference/"><SecondaryBtn>Všechny reference</SecondaryBtn></Link>
                </MoreLink>
            </BigCenter>

            <CTA/>
        </Layout>
    )
}

export default Welcome

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 4em;
  animation: ${fadeUp} 0.5s ease both;
  animation-delay: 0.55s;
`

const SectionLabel = styled.div`
  font-size: 0.75em;
  font-weight: 400;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  opacity: 0.5;
  margin-bottom: 1em;
`

const SectionTitle = styled.h2`
  font-size: 2.6em;
  font-weight: 800;
  margin: 0;
  letter-spacing: -0.02em;

  @media (max-width: 600px) {
    font-size: 2em;
  }
`

const MoreLink = styled.div`
  text-align: center;
  margin-top: 1em;
  margin-bottom: 2em;

  a {
    text-decoration: none;
  }
`
